<app-loading *ngIf="isLoading"></app-loading>
<button type="button" class="btn btn-outline-light cancel-gray cancel-edit-order" (click)="goToOrders()">Назад</button>
<div class="dashboard-body">
    <div class="top-white container" style="margin-top: 70px;">
        <div *ngIf="isOrderReturn" class="row topfeatures">
          <div [class]="order?.data?.invoice_address ? 'col-sm-3 column' :  'col-sm-6 column'" [style]="order?.data?.invoice_address ? 'font-size: 10pt' :  ''">
            <h5 style="font-weight: bold;">Поръчка</h5>
            <div class="row">
              <div class="col-sm-4 column labels">
                Поръчка:
              </div>
              <div class="col-sm-8 column">
                {{ order?.data?.uuid }}
              </div>

              <div class="col-sm-4 column labels">
                Заявка за връщане:
              </div>
              <div class="col-sm-8 column">
                {{ order?.data?.orderReturn.uuid }}
              </div>

              <div class="col-sm-4 column labels">
                Дата:
              </div>
              <div class="col-sm-8 column">
                {{ convertDate(order?.data?.orderReturn.created_at).date + ' '  +  convertDate(order?.data?.orderReturn.created_at).time }}
              </div>

              <div class="col-sm-4 column labels">
                Върни до:
              </div>
              <div class="col-sm-8 column" style="color: darkred">
                {{ getEndDate(order?.data?.created_at).date + ' '  +  getEndDate(order?.data?.created_at).time }}
              </div>

              <div class="col-sm-4 column labels">
                Завършена на:
              </div>
              <div class="col-sm-8 column">
                {{ order?.data?.orderReturn.state !== 'waiting' ?  convertDate(order?.data?.orderReturn.updated_at).date + ' '  +  convertDate(order?.data?.orderReturn.updated_at).time : ' ' }}
              </div>

              <div class="col-sm-4 column labels">
                Тип:
              </div>
              <div class="col-sm-8 column">
                {{ checkGroupType(order?.data?.group) }}
              </div>

              <div *ngIf="order?.data?.group" class="col-sm-4 column labels">
                Обем:
              </div>
              <div *ngIf="order?.data?.group" class="col-sm-8 column">
                {{ groupCount }}
              </div>

              <div class="col-sm-4 column labels">
                Статус:
              </div>
              <div class="col-sm-8 column" [style]="'color: ' + orderStatusColor + ';'">
                {{ convertOrderStatus(order?.data?.orderReturn.state) }}
              </div>

              <div *ngIf="cancellationFee !== '-'" class="col-sm-4 column labels">
                Такса отказ:
              </div>
              <div *ngIf="cancellationFee !== '-'" class="col-sm-8 column">
                {{ cancellationFee }}
              </div>

              <div class="col-sm-4 column labels">
                Такса 5%:
              </div>
              <div class="col-sm-8 column">
                {{ getRefundFee() }}
              </div>

              <div class="col-sm-4 column labels">
                Възстановена такса:
              </div>
              <div class="col-sm-8 column">
                {{ getDeliveryRevertFee() }}
              </div>

              <div class="col-sm-4 column labels">
                Причина:
              </div>
              <div class="col-sm-8 column">
                {{ order?.data?.orderReturn.return_reason || '-' }}
              </div>
            </div>
          </div>

          <div class="col-sm-3 column" style="font-size: 10pt;">
            <h5 style="font-weight: bold;">Данни за връщане</h5>
            <div class="row">
              <div class="row">
                <div class="col-sm-4 column labels">
                  Име :
                </div>
                <div  class="col-sm-8">
                  {{ order?.data?.delivery_address?.name }}
                </div>

                <div  class="col-sm-8">
                  {{ order?.data?.delivery_address?.mobile_phone_1_e164 }}
                </div>
                <div class="col-sm-4 column labels">
                  Телефон:
                </div>

                <div class="col-sm-4 column labels">
                  Адрес:
                </div>
                <div  class="col-sm-8">
                  {{ buildAddressDetails(order?.data?.delivery_address) }}
                </div>

                <div class="col-sm-4 column labels">
                  Град:
                </div>
                <div  class="col-sm-8">
                  {{ order?.data?.delivery_address?.city }}
                </div>

                <div class="col-sm-4 column labels">
                  Пощенски код:
                </div>
                <div  class="col-sm-8">
                  {{ order?.data?.delivery_address?.post_code != '0000' ? order?.data?.delivery_address?.post_code : '-' }}
                </div>

                <div class="col-sm-4 column labels">
                  Банка:
                </div>
                <div  class="col-sm-8">
                  {{ order?.data?.orderReturn.bank_name }}
                </div>

                <div class="col-sm-4 column labels">
                  IBAN:
                </div>
                <div  class="col-sm-8">
                  {{ order?.data?.orderReturn.iban}}
                </div>

                <div class="col-sm-4 column labels">
                  Титуляр:
                </div>
                <div class="col-sm-8">
                  {{ order?.data?.orderReturn.account_owner}}
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-3 column" style="font-size: 10pt;" *ngIf="order?.data?.invoice_address">
            <h5 style="font-weight: bold;">Данни за фактура</h5>
            <div class="row" *ngIf="order?.data?.invoice_address?.type.label == 'USER_INVOICE_ADDRESS'
                                          || order?.data?.invoice_address?.type.label ==  'USER_SHIPPING_TYPE_CONTACT'
                                          || order?.data?.invoice_address?.type.label ==  'USER_INVOICE_TYPE_CONTACT'
                                          || order?.data?.invoice_address?.type.label == 'USER_SHIPPING_OFFICE_TYPE_CONTACT'">
              <div class="col-sm-4 column labels">
                Име:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.name }}
              </div>

              <div class="col-sm-4 column labels">
                Телефон:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.mobile_phone_1_e164 }}
              </div>

              <div class="col-sm-4 column labels">
                Адрес:
              </div>
              <div class="col-sm-8">
                {{ buildAddressDetails(order?.data?.invoice_address) }}
              </div>

              <div class="col-sm-4 column labels">
                Град:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.city }}
              </div>

              <div class="col-sm-4 column labels">
                Пощенски код:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.post_code != '0000' ? order?.data?.invoice_address?.post_code : '-' }}
              </div>

              <div class="col-sm-4 column labels">
                Платежен метод:
              </div>
              <div class="col-sm-8">
                {{ paymentType(order?.data?.paymentMethod.code) }}
              </div>
            </div>
            <div class="row" *ngIf="order?.data?.invoice_address?.type.label == 'COMPANY_INVOICE_ADDRESS'
                                          || order?.data?.invoice_address?.type.label == 'USER_COMPANY_INVOICE_TYPE_CONTACT'">
              <div class="col-sm-4 column labels">
                Фирма:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.company_name }}
              </div>
              <div class="col-sm-4 column labels">
                ЕИК:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.company_number }}
              </div>
              <div class="col-sm-4 column labels">
                ДДС №:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.company_vat_number }}
              </div>
              <div class="col-sm-4 column labels">
                Адрес:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.address_line_2 + ' '
              + order?.data?.invoice_address?.city + ' '
              + order?.data?.invoice_address?.post_code }}
              </div>
              <div class="col-sm-4 column labels">
                МОЛ:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.company_owner }}
              </div>
              <div class="col-sm-4 column labels">
                Тел.:
              </div>
              <div class="col-sm-8">
                {{ order?.data?.invoice_address?.mobile_phone_1_e164 }}
              </div>
              <div class="col-sm-4 column labels">
                Платежен метод:
              </div>
              <div class="col-sm-8">
                {{ paymentType(order?.data?.paymentMethod.code) }}
              </div>
            </div>
          </div>

          <div [class]="order?.data?.invoice_address ? 'col-sm-3 column' :  'col-sm-6 column'" [style]="order?.data?.invoice_address ? 'font-size: 10pt' :  ''" style="margin-top: 20px;">
            <h5 style="font-weight: bold;">&nbsp;</h5>
            <div class="row">
              <div class="col-sm-8 column labels">
                Сума за възстановяване:
              </div>
              <div class="col-sm-4 d-flex justify-content-end px-1">
                {{ formatPrice(totalRequestRefund) }}
              </div>
              <hr style="color: #99A3BF; width: 100%; margin-top: 10px; margin-bottom: 10px;">
              <div class="col-sm-8 column bolded" style="font-weight: bold">
                Възстановена сума:
              </div>
              <div class="col-sm-4 column bolded d-flex justify-content-end px-1" style="font-weight: bold">
                <span>{{ order?.data?.orderReturn?.amount_refunded == 0 ? '-' : formatPrice(order?.data?.orderReturn?.amount_refunded) }}</span>
              </div>
              <button *ngIf="isCOD(order?.data?.paymentMethod.code)" style="width: 100%; height: auto;  margin-top: 20px; margin-bottom: 20px;" class="btn btn-primary" (click)="openReturnOrderDialog($event)" disabled="{{order.data.orderReturn.state !== 'waiting' ? 'disabled' : ''}}">Възстановена сума</button>
              <p *ngIf="isCOD(order?.data?.paymentMethod.code)" style="color: #75809C">*Поръчката е платена с Наложен платеж, трябва да възстановите сумата на клиента, чрез вашата банкова сметка и след това да въведете тук възстановената сума.</p>

              <button *ngIf="!isCOD(order?.data?.paymentMethod.code)" style="width: 100%; height: auto;  margin-top: 20px; margin-bottom: 20px;" class="btn btn-primary" (click)="openReturnOrderDialog($event)" disabled="{{order.data.orderReturn.state !== 'waiting' ? 'disabled' : ''}}">Възстанови чрез ShareMe</button>
              <p *ngIf="!isCOD(order?.data?.paymentMethod.code)" style="color: #75809C">*Поръчката е платена с карта, въведете желаната сума за възстановяване и ShareMe ще я възстанови на клиента от ваше име и ще приспаднем сумата от следващото ви изплащане на оборота. Възстановяването отнема 2-3 дни до достигане на сумата до клиента.</p>
            </div>
          </div>
        </div>

        <!------------------ If not Returned Order ---------------------->

        <div *ngIf="!isOrderReturn" class="row topfeatures">
            <div [class]="order?.data?.invoice_address ? 'col-sm-3 column' :  'col-sm-6 column'" [style]="order?.data?.invoice_address ? 'font-size: 10pt' :  ''">
                <h5 style="font-weight: bold;">Поръчка</h5>
                <div class="row">
                    <div class="col-sm-4 column labels">
                        Дата:
                    </div>
                    <div class="col-sm-8 column">
                        {{ convertDate(order?.data?.created_at).date + ' '  +  convertDate(order?.data?.created_at).time }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Поръчка:
                    </div>
                    <div class="col-sm-8 column">
                        {{ order?.data?.uuid }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Тип:
                    </div>
                    <div class="col-sm-8 column">
                        {{ checkGroupType(order?.data?.group) }}
                    </div>

                    <div *ngIf="order?.data?.group" class="col-sm-4 column labels">
                      Обем:
                    </div>
                    <div *ngIf="order?.data?.group" class="col-sm-8 column">
                      {{ groupCount }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Статус поръчка:
                    </div>
                    <div class="col-sm-8 column" [style]="'color: ' + orderStatusColor + ';'">
                        {{ convertOrderStatus(order?.data?.state) }}
                    </div>

                    <div *ngIf="currentShipment" class="col-sm-4 column labels">
                        Статус доставка:
                    </div>
                    <div *ngIf="currentShipment" class="col-sm-8 column">
                        {{ shipmentStatus }}
                    </div>

                    <div *ngIf="shipmentStatusNote !== '-'" class="col-sm-4 column labels">
                        Последен статус:
                    </div>
                    <div *ngIf="shipmentStatusNote !== '-'" class="col-sm-8 column">
                        {{ shipmentStatusNote }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Товар. №:
                    </div>
                    <div class="col-sm-8 column">
                        {{ currentShipment?.carrier_shipment_identifier || '-' }}
                    </div>

                    <div *ngIf="deliveredFee !== '-'" class="col-sm-4 column labels">
                      Комисион:
                    </div>
                    <div *ngIf="deliveredFee !== '-'" class="col-sm-8 column">
                      {{ deliveredFee }}
                    </div>

                    <div *ngIf="cancellationFee !== '-'" class="col-sm-4 column labels">
                        Такса отказ:
                    </div>
                    <div *ngIf="cancellationFee !== '-'" class="col-sm-8 column">
                        {{ cancellationFee }}
                    </div>
                    <div *ngIf="order?.data?.state == 'cancelled'" class="col-sm-4 column labels">
                        Дата на отказ:
                    </div>
                    <div *ngIf="order?.data?.state == 'cancelled'" class="col-sm-8 column">
                        {{  convertDate(order?.data?.updated_at).date + ' '  +  convertDate(order?.data?.updated_at).time }}
                    </div>
                    <div *ngIf="order?.data?.state == 'returned'" class="col-sm-4 column labels">
                        Такса 5%:
                    </div>
                    <div *ngIf="order?.data?.state == 'returned'" class="col-sm-8 column">
                        {{ order?.data?.total_tax_amount }}
                    </div>
                    <div *ngIf="order?.data?.state == 'returned'" class="col-sm-4 column labels">
                        Причина:
                    </div>
                    <div *ngIf="order?.data?.state == 'returned'" class="col-sm-8 column">
                        {{ order?.data?.refund_reason || '-' }}
                    </div>
                    <div *ngIf="order?.data?.state == 'returned'" class="col-sm-4 column labels">
                        Възстановена такса:
                    </div>
                    <!-- <div *ngIf="this.order?.data?.state == 'cancelled'" class="col-sm-8 column">
                        {{ this.order?.data?.total_tax_amount }}
                    </div> -->
                </div>
            </div>
            <div class="col-sm-3 column" style="font-size: 10pt;" *ngIf="order?.data?.invoice_address">
                <h5 style="font-weight: bold;">Данни за фактура</h5>
                <div class="row" *ngIf="order?.data?.invoice_address?.type.label == 'USER_INVOICE_ADDRESS'
                                        || order?.data?.invoice_address?.type.label ==  'USER_SHIPPING_TYPE_CONTACT'
                                        || order?.data?.invoice_address?.type.label ==  'USER_INVOICE_TYPE_CONTACT'
                                        || order?.data?.invoice_address?.type.label == 'USER_SHIPPING_OFFICE_TYPE_CONTACT'">
                    <div class="col-sm-4 column labels">
                        Име:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.name }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Телефон:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.mobile_phone_1_e164 }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Адрес:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ buildAddressDetails(order?.data?.invoice_address) }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Град:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.city }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Пощенски код:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.post_code != '0000' ? order?.data?.invoice_address?.post_code : '-' }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Платежен метод:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                         {{ paymentType(order?.data?.paymentMethod.code) }}
                    </div>
                </div>
                <div class="row" *ngIf="order?.data?.invoice_address?.type.label == 'COMPANY_INVOICE_ADDRESS'
                                        || order?.data?.invoice_address?.type.label == 'USER_COMPANY_INVOICE_TYPE_CONTACT'">
                    <div class="col-sm-4 column labels">
                        Фирма:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.company_name }}

                    </div>

                    <div class="col-sm-4 column labels">
                        ЕИК:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.company_number }}

                    </div>

                    <div class="col-sm-4 column labels">
                        ДДС №:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.company_vat_number }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Адрес:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.address_line_2 + ' '
                            + order?.data?.invoice_address?.city + ' '
                            + order?.data?.invoice_address?.post_code }}

                    </div>

                    <div class="col-sm-4 column labels">
                        МОЛ:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.company_owner }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Тел.:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.invoice_address?.mobile_phone_1_e164 }}

                    </div>

                    <div class="col-sm-4 column labels">
                        Платежен метод:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ paymentType(order?.data?.paymentMethod.code) }}
                    </div>
                </div>
            </div>
            <div class="col-sm-3 column" style="font-size: 10pt;" *ngIf="order?.data?.delivery_address">
                <h5 style="font-weight: bold;">Данни за доставка</h5>
                <div class="row">
                    <div class="col-sm-4 column labels">
                        Име :
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.delivery_address?.name }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Телефон:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.delivery_address?.mobile_phone_1_e164 }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Метод на доставка:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ convertShipmentMethod(order?.data?.delivery_method) }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Адрес:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ buildAddressDetails(order?.data?.delivery_address) }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Град:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.delivery_address?.city }}
                    </div>

                    <div class="col-sm-4 column labels">
                        Пощенски код:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                        {{ order?.data?.delivery_address?.post_code != '0000' ? order?.data?.delivery_address?.post_code : '-' }}
                    </div>
                </div>
            </div>
            <div [class]="order?.data?.invoice_address ? 'col-sm-3 column' :  'col-sm-6 column'" [style]="order?.data?.invoice_address ? 'font-size: 10pt' :  ''">
                <h5 style="font-weight: bold;">&nbsp;</h5>
                <div *ngIf="order?.data?.state == 'returned'" class="row">
                    <div class="col-sm-4 column labels">
                        Сума за възстановяване:
                    </div>
                    <div [class]="classForSensitiveInfo"  data-bs-toggle="tooltip" [ngbTooltip]="(classForSensitiveInfo.includes('blurry')) ? 'Данните ще бъдат видими след потвърждаване на поръчката.' : ''">
                      {{ formatPrice(order?.data?.amount_refunded) }}
                    </div>
                    <div class="col-sm-6 column bolded" style="font-weight: bold">
                        Възстановена сума:
                    </div>
                    <div class="col-sm-6 column bolded" style="font-weight: bold">
                      {{ formatPrice(order?.data?.amount_refunded) }}
                    </div>

                    <button *ngIf="isCOD(order?.data?.paymentMethod.code)" style="margin: 5px; width: 160px; height: 45px; display: block; margin-bottom: 10px;" class="btn btn-primary" (click)="refund()">Възстановена сума</button>
                    <p *ngIf="isCOD(order?.data?.paymentMethod.code)" style="color: #75809C">*Поръчката е платена с Наложен платеж, трябва да възстановите сумата на клиента, чрез вашата банкова сметка и след това да въведете тук възстановената сума.</p>

                    <button *ngIf="!isCOD(order?.data?.paymentMethod.code)" style="margin: 5px; width: 160px; height: 45px; display: block; margin-bottom: 10px;" class="btn btn-primary" (click)="refund()">Възстанови чрез ShareMe</button>
                    <p *ngIf="!isCOD(order?.data?.paymentMethod.code)" style="color: #75809C">*Поръчката е платена с карта, въведете желата сума за възстановяване и ShareMe ще я възстнови на клиента от ваше име и ще приспадне сумат от следващото ви изплащане на оборота. Възстановяването отнема 2-3 дни до достигане на сумата до клиента.</p>
                </div>
                <div *ngIf="order?.data?.state != 'returned'" class="row">
                    <div class="col-sm-6 column labels marginBottom">
                        Ваучер:
                    </div>
                    <div class="col-sm-6 column marginBottom">
                      {{ formatPrice(order?.data?.voucher_amount || 0) }}
                    </div>

                    <div class="col-sm-6 column labels marginBottom">
                        Междинна сума:
                    </div>
                    <div class="col-sm-6 column marginBottom">
                      {{ formatPrice(order?.data?.total_gross) }}
                    </div>

                    <div class="col-sm-6 column labels marginBottom">
                        Доставка:
                    </div>
                    <div class="col-sm-6 column marginBottom">
                      {{ formatPrice(order?.data?.shipment_cost) }}
                    </div>
                    <hr style=" margin: auto; color: #99A3BF; width: 100%; margin: auto; margin-top: 10px; margin-bottom: 20px;">
                    <div class="col-sm-6 column bolded"  >
                        Общо:
                    </div>
                    <div class="col-sm-6 column bolded">
                      {{ formatPrice(orderTotal) }}
                    </div>

                    <div style="margin-top: 10px;" class="col-sm-12 column" *ngIf="orderRightPanel == 'to_confirm'">
                        <button style="margin: 5px; width: 148px; height: 45px; display: block;  margin: auto;" class="btn btn-primary" (click)="confirmOrder()">Потвърди</button>
                    </div>

                    <div style="margin-top: 10px;"  class="col-sm-12 column" *ngIf="orderRightPanel == 'normal'">
                        <button style="margin: 5px; width: 100%; font-size: 9pt; height: 45px; display: block; margin: auto; margin-bottom: 10px; margin-top: 10px;" class="btn btn-primary" (click)="generateShipment()">Генерирай товарителница</button>
                        <button style="margin: 5px; width: 100%; font-size: 9pt; height: 45px; display: block; margin: auto; margin-bottom: 10px; margin-top: 10px;" type="button" class="btn btn-outline-dark" (click)="printStockReciept()">Отпечатай стокова разписка</button>
                    </div>

                    <div style="margin-top: 10px;"  class="col-sm-12 column" *ngIf="orderRightPanel == 'completed'">
                        <div class="row">
                            <div class="col-sm-12" style="padding-left: 5px; padding-right: 5px;">
                                <button style="width: 100%;  font-size: 9pt; height: 45px; display: block;  margin: auto;" type="button" class="btn btn-outline-dark" (click)="printWayBill()">Товарителница</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="padding-left: 5px; padding-right: 5px;">
                                <button style="margin: 5px; width: 100%; font-size: 9pt; height: 45px; display: block; margin: auto; margin-bottom: 10px; margin-top: 10px;" type="button" class="btn btn-outline-dark" (click)="printStockReciept()">Отпечатай стокова разписка</button>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 10px;"  class="col-sm-12 column" *ngIf="orderRightPanel == 'with_shipment'">
                        <div class="row" *ngIf="shouldShowPickUpBtn(order)">
                            <div class="col-sm-6" style="padding-left: 5px; padding-right: 5px;">
                                <button style="width: 100%;  font-size: 9pt;  height: 45px; display: block; margin: auto;" class="btn btn-primary" (click)="generateShipment()">Заяви за вземане</button>
                            </div>
                            <div class="col-sm-6" style="padding-left: 5px; padding-right: 5px;">
                                <button style="width: 100%;  font-size: 9pt; height: 45px; display: block; margin: auto;" type="button" class="btn btn-outline-dark" (click)="printWayBill()">Товарителница</button>
                            </div>
                        </div>
                        <div class="row" *ngIf="!shouldShowPickUpBtn(order) && order?.data?.state !== 'delivered'">
                            <div class="col-sm-12" style="padding-left: 5px; padding-right: 5px;">
                                <button style="width: 100%;  font-size: 9pt; height: 45px; display: block; margin: auto;" type="button" class="btn btn-primary" (click)="printWayBill()">Товарителница</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" style="padding-left: 5px; padding-right: 5px;">
                                <button style="margin: 5px; width: 100%; font-size: 9pt; height: 45px; display: block; margin: auto; margin-bottom: 10px; margin-top: 10px;" type="button" class="btn btn-outline-dark" (click)="printStockReciept()">Отпечатай стокова разписка</button>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 10px;"  class="col-sm-12 column" *ngIf="orderRightPanel == 'cancelled'">
                        <div class="row">
                            <div class="col-sm-12" style="padding-left: 5px; padding-right: 5px;">
                                <button style="margin: 5px; width: 100%; font-size: 9pt; height: 45px; display: block; margin: auto; margin-bottom: 10px; margin-top: 10px;" type="button" class="btn btn-outline-dark" (click)="printStockReciept()">Отпечатай стокова разписка</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-------------------- Return Products -------------------->
    <div style="margin-bottom: 10px;" class="bottom-white container" *ngIf="returnedOrdersDataSource.length">
      <h5 style="font-weight: bold;">Заявени продукти за връщане ({{ returnedOrdersDataSource.length }})</h5>
      <div class="row topfeatures" style="margin-top: 10px;">
        <table #returnedProductTable mat-table  multiTemplateDataRows  [dataSource]="returnedOrdersDataSource" matSort  class="mat-elevation-z8 products" style="text-align: center; width: -webkit-fill-available;">
          <ng-container matColumnDef="Product">
            <th mat-header-cell *matHeaderCellDef style="width: 450px;"> {{dashboardLables(getPageName()).image}} </th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; width: 450px;">
                        <span *ngIf="element">
                            <img [src]="element.imageSource" alt="" style="width: 170px !important; border-top: unset; vertical-align: top;" class="product-image-field">
                            <div class="p-display-block" style="display: inline-block; margin-left: 7px">
                                <p style="font-weight: bold;  font-size: 18px; text-wrap: wrap; width: 230px;">
                                    {{ element.sku.product.name }}
                                </p>
                                <p style="font-size: 16px;">
                                    <span style="color: #75809C">SKU:</span> {{ element.sku.sku }} <br> <span style="color: #75809C">EAN:</span> {{ element.sku.product.organisation.number }}
                                </p>
                                <p style="font-size: 16px;" *ngIf="orderVariationsIfAny(element)">
                                    <span *ngFor="let orderOption of orderVariationsIfAny(element)">
                                        <span style="color: #75809C">{{ orderOption.name }}: </span> {{ orderOption.value }} <br>
                                    </span>
                                </p>
                            </div>
                        </span>
              <p *ngIf="!element.editable" style="font-weight: bold; text-align: left;">
                <span style="position: relative; left: 170px"> {{ element.sku.product.name }} </span>
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="Quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 70px;">{{dashboardLables(getPageName()).qty}}</th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ element.quantity + ' бр.' }} </td>
          </ng-container>
          <ng-container matColumnDef="PricePerPiece">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><span>{{dashboardLables(getPageName()).qtypp}}</span>&nbsp;<small id="pricePerPieceReturned" class="text-muted" data-bs-toggle="tooltip" title="Цената за 1бр. от продукта"></small></th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(getPriceForFirstRange(element)) }} </td>
          </ng-container>
          <ng-container matColumnDef="Net">
            <th mat-header-cell *matHeaderCellDef> {{dashboardLables(getPageName()).pricenet}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_net) }} </td>
          </ng-container>
          <ng-container matColumnDef="Vat">
            <th mat-header-cell *matHeaderCellDef style="width: 70px;"> {{dashboardLables(getPageName()).vat}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ convertVatPercentage(element) + '%' }} </td>
          </ng-container>

          <ng-container matColumnDef="Price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 70px;"> {{dashboardLables(getPageName()).pricegross}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_gross) }} </td>
          </ng-container>

          <ng-container matColumnDef="Total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right !important; width: 130px; "> {{dashboardLables(getPageName()).sum}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field" style="text-align: right !important;"> <span>{{ formatPrice(getReturnedTotalAmount(element)) }}</span> </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsForReturnedProductTable"></tr>
          <tr  mat-row *matRowDef="let element; columns: displayedColumnsForReturnedProductTable;">
          </tr>
        </table>
      </div>
    </div>

    <div style="margin-bottom: 10px;" class="bottom-white container" *ngIf="ordersDataSource.length">
      <h5 style="font-weight: bold;">Поръчка #{{ order?.data?.uuid }} от {{ convertDateOrder(order?.data?.created_at).date + ', '  +  convertDateOrder(order?.data?.created_at).time }}</h5>
      <div class="row topfeatures" style="margin-top: 10px;">
        <table #productTable mat-table  multiTemplateDataRows  [dataSource]="ordersDataSource" matSort  class="mat-elevation-z8 products" style="text-align: center; width: -webkit-fill-available;">
          <ng-container matColumnDef="Product">
            <th mat-header-cell *matHeaderCellDef style="width: 450px;"> {{dashboardLables(getPageName()).image}} </th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; width: 450px;">
                    <span *ngIf="element.editable">
                        <img [src]="element.imageSource" alt="" style="width: 170px !important; border-top: unset; vertical-align: top;" class="product-image-field">
                        <div class="p-display-block" style="display: inline-block; margin-left: 7px">
                            <p style="font-weight: bold;  font-size: 18px; text-wrap: wrap; width: 230px;">
                                {{ element.sku.product.name }}
                            </p>
                            <p style="font-size: 16px;">
                                <span style="color: #75809C">SKU:</span> {{ element.sku.sku }} <br> <span style="color: #75809C">EAN:</span> {{ element.sku.product.organisation.number }}
                            </p>
                            <p style="font-size: 16px;" *ngIf="orderVariationsIfAny(element)">
                                <span *ngFor="let orderOption of orderVariationsIfAny(element)">
                                    <span style="color: #75809C">{{ orderOption.name }}: </span> {{ orderOption.value }} <br>
                                </span>
                            </p>
                        </div>
                    </span>
              <p *ngIf="!element.editable" style="font-weight: bold; text-align: left;">
                <span style="position: relative; left: 170px"> {{ element.sku.product.name }} </span>
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="Quantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 70px;">{{dashboardLables(getPageName()).qty}}</th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ (element.editable) ? element.quantity + ' бр.' : '-'}} </td>
          </ng-container>

          <ng-container matColumnDef="PricePerPiece">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><span>{{dashboardLables(getPageName()).qtypp}}</span>&nbsp;<small id="pricePerPiece" class="text-muted" data-bs-toggle="tooltip" title="Цената за 1бр. от продукта"></small></th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ element.editable ? formatPrice(getPriceForFirstRange(element)) : '-' }} </td>
          </ng-container>

          <ng-container matColumnDef="Net">
            <th mat-header-cell *matHeaderCellDef> {{dashboardLables(getPageName()).pricenet}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_net) }} </td>
          </ng-container>

          <ng-container matColumnDef="Vat">
            <th mat-header-cell *matHeaderCellDef style="width: 70px;"> {{dashboardLables(getPageName()).vat}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ convertVatPercentage(element) + '%' }} </td>
          </ng-container>

          <ng-container matColumnDef="Price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 70px;"> {{dashboardLables(getPageName()).pricegross}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_gross) }} </td>
          </ng-container>

          <ng-container matColumnDef="Total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right !important; width: 130px; "> {{dashboardLables(getPageName()).sum}} </th>
            <td mat-cell *matCellDef="let element" class="product-name-field" style="text-align: right !important;"> <span>{{ formatPrice(getLineTotalAmount(element)) }}</span> </td>
          </ng-container>

          <!-- <ng-container  *ngIf="this.order?.data?.state == 'pending'"  matColumnDef="action"> -->
          <ng-container    matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element" class="product-name-field" style="max-width: 160px; width: 150px">
              <button *ngIf="canCancelLine(element)" style="margin: 5px; width: 148px; height: 45px; display: block; margin: auto; margin-bottom: 10px; color: #E53E3E;" type="button" class="btn btn-outline-light cancel" (click)="cancelOrderLine(element)">Откажи</button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsForProductTable"></tr>
          <tr  mat-row *matRowDef="let element; columns: displayedColumnsForProductTable;">
          </tr>
        </table>

        <div class="col-sm-6 column p-display-block" style="margin-top: 30px;">
          <p>Междина сума:</p>
          <p>Доставка (с ДДС):</p>
          <p style="font-weight: bold;">ОБЩО:</p>
        </div>
        <div class="col-sm-6 column p-display-block" style="text-align: center; margin-top: 30px;">
          <div style="width: fit-content; position: relative; right: 144px; float: right;">
            <p style="width: fit-content;">{{ formatPrice(order?.data?.total_gross) }}</p>
            <p style="width: fit-content;">{{ formatPrice(order?.data?.shipment_cost) }}</p>
            <p style="font-weight: bold; width: fit-content;">{{ formatPrice(orderTotal) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 10px;" class="bottom-white container" *ngIf="cancelledOrdersDataSource.length">
        <h3 style="color: #E53E3E; font-weight: 500;">Отказани продукти</h3>
        <div *ngIf="cancelledOrdersDataSource.length" class="row topfeatures">

            <table #cancelledProductTable mat-table  multiTemplateDataRows  [dataSource]="cancelledOrdersDataSource" matSort  class="mat-elevation-z8 products" style="text-align: center; width: -webkit-fill-available;">
                <ng-container matColumnDef="Product">
                    <th mat-header-cell *matHeaderCellDef  style="width: 450px;"> {{dashboardLables(getPageName()).image}} </th>
                    <td mat-cell *matCellDef="let element" style="vertical-align: middle; width: 450px;">
                      <span *ngIf="element.editable">
                          <img [src]="element.imageSource" alt="" style="width: 170px !important; border-top: unset; vertical-align: top;" class="product-image-field">
                          <div class="p-display-block" style="display: inline-block; margin-left: 7px">
                              <p style="font-weight: bold;  font-size: 18px; text-wrap: wrap; width: 230px;">
                                  {{ element.sku.product.name }}
                              </p>
                              <p style="font-size: 16px;">
                                  <span style="color: #75809C">SKU:</span> {{ element.sku.sku }} <br> <span style="color: #75809C">EAN:</span> {{ element.sku.product.organisation.number }}
                              </p>
                              <p style="font-size: 16px;" *ngIf="orderVariationsIfAny(element)">
                                  <span *ngFor="let orderOption of orderVariationsIfAny(element)">
                                      <span style="color: #75809C">{{ orderOption.name }}: </span> {{ orderOption.value }} <br>
                                  </span>
                              </p>
                          </div>
                      </span>
                      <p *ngIf="!element.editable" style="font-weight: bold; text-align: left;">
                          <span style="position: relative; left: 170px"> {{ element.sku.product.name }} </span>
                      </p>
                   </td>
                  </ng-container>
                  <ng-container matColumnDef="Quantity">
                    <th mat-header-cell *matHeaderCellDef style="width: 70px;" mat-sort-header>{{dashboardLables(getPageName()).qty}}</th>
                    <td mat-cell *matCellDef="let element" class="product-name-field"> {{ (element.editable) ? element.quantity + ' бр.' : '-'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="PricePerPiece">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 130px;"><span>{{dashboardLables(getPageName()).qtypp}}</span>&nbsp;<small id="emailHelp" class="text-muted" data-bs-toggle="tooltip" title="Цената за 1бр. от продукта"></small></th>
                    <td mat-cell *matCellDef="let element" class="product-name-field"> {{ element.editable ? formatPrice(getPriceForFirstRange(element)) : '-' }} </td>

                  </ng-container>
                  <ng-container matColumnDef="Net">
                    <th mat-header-cell *matHeaderCellDef style="width: 130px;"> {{dashboardLables(getPageName()).pricenet}} </th>
                    <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_net) }} </td>
                  </ng-container>
                  <ng-container matColumnDef="Vat">
                      <th mat-header-cell *matHeaderCellDef style="width: 70px;"> {{dashboardLables(getPageName()).vat}} </th>
                      <td mat-cell *matCellDef="let element" class="product-name-field"> {{ convertVatPercentage(element) + '%' }} </td>
                  </ng-container>

                  <ng-container matColumnDef="Price">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 130px;"> {{dashboardLables(getPageName()).pricegross}} </th>
                      <td mat-cell *matCellDef="let element" class="product-name-field"> {{ formatPrice(element.single_gross) }} </td>
                  </ng-container>

                  <ng-container matColumnDef="Total">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 70px;"> {{dashboardLables(getPageName()).sum}} </th>
                      <td mat-cell *matCellDef="let element" class="product-name-field"> {{ element.editable ? formatPrice(getCancelledTotalAmount(element)) : '-' }} </td>
                  </ng-container>

                  <!-- <ng-container  *ngIf="this.order?.data?.state == 'pending'"  matColumnDef="action"> -->
                  <ng-container    matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 150px; width: 150px"> </th>
                      <td mat-cell *matCellDef="let element" class="product-name-field">
                          <!-- <button *ngIf="element.editable" style="margin: 5px; width: 148px; height: 45px; display: block; margin-bottom: 10px; color: #0A69EB;" type="button" class="btn btn-outline-dark cancel" (click)="this.cancelOrderLine(element)">Откажи</button> -->
                      </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsForCancledProductTable"></tr>
                  <tr  mat-row *matRowDef="let element; columns: displayedColumnsForCancledProductTable;">
              </tr>
            </table>
        </div>
    </div>
</div>


<ng-template #cancelWindow let-modal>
    <div style="text-align: center; padding: 30px;">
        <h4>Желаете ли да откажете продукта?</h4>
        <h6 style="color: #99A3BF; margin-top: 30px; margin-bottom: 20px;">При отказването на продукт {{selectedOrderLine?.sku.product.name }} ще бъде начислена такса "Отказ" 9.17% (без ДДС) от сумата на отказаното количество. Ще бъде отказан само 1бр. от продукта.</h6>
        <div class="text-left" style="margin-bottom: 20px;">
            <label for="order-line-cancellation-reason">Причина за отказване на продукта <span style="color: #E53E3E;">*</span></label>
            <select id="order-line-cancellation-reason" class="form-control" [(ngModel)]="cancellationReason">
                <option value="" disabled>Изберете причина</option>
                <option *ngFor="let reason of cancellationReasons" [value]="reason.value">{{ reason.label }}</option>
            </select>
            <div *ngIf="isOtherCancellationReason" style="margin-top: 10px;">
                <label>Коментар <span style="color: #E53E3E;">*</span></label>
                <textarea class="form-control"
                          rows="3"
                          maxlength="1000"
                          [(ngModel)]="cancellationComment"
                          placeholder="Опишете причината"></textarea>
            </div>
        </div>
        <div mat-dialog-actions>
            <button class="btn btn-primary" style="border-radius: 10px; color: #E53E3E; background-color: white; border: 1px solid #B6BFD6;  width: 45%; margin-right: 10px;" mat-button [disabled]="!canCancelOrderLine" (click)="cancel()">Откажи продукт </button>
            <button class="btn btn-primary" style="border-radius: 10px; width: 45%;" mat-button (click)="modal.close()" cdkFocusInitial>Не сега</button>
          </div>
    </div>
</ng-template>

<ng-template #returnWindow let-modal>
  <div style="text-align: center; padding: 30px;">
    <h4>{{ returnWindowTitle }}</h4>
    <h6 style="color: #99A3BF; margin-top: 30px; margin-bottom: 30px;">{{ returnWindowText }}</h6>
    <div class="container" style="width: 80%; margin-bottom: 30px;">
      <div class="row" style="margin-bottom: 10px;">
        <div class="col-sm-8 d-flex justify-content-between" style="padding: 0;">
          Сума на продукти:
        </div>
        <div class="col-sm-4 d-flex justify-content-end" style="padding: 0;font-weight: bold;">
          {{ formatPrice(calculateRequestRefund()) }}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8  d-flex justify-content-between" style="padding: 0;">
          {{ returnPriceText }}
        </div>
        <div class="col-sm-4 d-flex justify-content-end" style="padding: 0;font-weight: bold;">
          <input id="amountRequest"
                 matInput
                 type="text"
                 [value]="formattedAmountRequestedInput"
                 (input)="onAmountInputChange($event)"
                 (keydown)="onAmountKeyDown($event)"
                 (blur)="onAmountBlur()"
          > {{ currencySymbol }}
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="mt-2">
      <button class="btn btn-primary" style="border-radius: 10px; color: #E53E3E; background-color: white; border: 1px solid #B6BFD6;  width: 45%; margin-right: 10px;" mat-button (click)="modal.close()">Затвори </button>
      <button class="btn btn-primary" style="border-radius: 10px; width: 45%;" mat-button (click)="confirmReturn()" cdkFocusInitial>{{ returnButtonTitle }}</button>
    </div>
  </div>
</ng-template>
